export default (state = [], action) => {
  switch (action.type){

    case 'ADD_NEW_ORDER':
		//console.log('ADD_NEW_ORDER reducer');
		const maxId = Math.max(...state.map(order => order.id));
    	return [...state, {id: maxId+1, comment:"", reference:"", doc:{}, attachment:{}, task:[], product:[], urgent:false, special:false, quotation:false, alerta:false, enabled:true}];

	case 'REMOVE_ORDER':
		//let newState = state.filter(item => item.id !== action.id);
		let newState = state.map(item => {if (item.id === action.id) {item.enabled=false;} return item;} );
		return newState;
	
	case 'RESET_PROJECT':
		//console.log('RESET_PROJECT reducer');
    	return [{id: 0, comment:"", reference:"", doc:{}, attachment:{}, task:[], product:[], urgent:false, special:false, quotation:false, alerta:false, enabled:true}];
		
	case 'UPDATE_COMMENT':
		//console.log('UPDATE_COMMENT reducer');
		const updatedItems = state.map(item => {
			if(item.id === action.id){
				var temp = JSON.parse(JSON.stringify(item));
				temp.comment=action.comment;
				return { ...temp, doc: new File([item.doc], item.doc.name, { type: item.doc.type }), attachment: new File([item.attachment], item.attachment.name, { type: item.attachment.type })};
			}
			return item;
		})
		//console.log('updatedItems: '+JSON.stringify(updatedItems));
		return updatedItems;
		
	case 'UPDATE_REFERENCE':
		//console.log('UPDATE_REFERENCE reducer');
		const updatedItems2 = state.map(item => {
			if(item.id === action.id){
				var temp = JSON.parse(JSON.stringify(item));
				temp.reference=action.reference;
				return { ...temp, doc: new File([item.doc], item.doc.name, { type: item.doc.type }), attachment: new File([item.attachment], item.attachment.name, { type: item.attachment.type })};
			}
			return item;
		})
		//console.log('updatedItems: '+JSON.stringify(updatedItems2));
		return updatedItems2;
	
	case 'UPDATE_DOCUMENT':
		//console.log('UPDATE_DOCUMENT reducer');
		const updatedItems3 = state.map(item => {
			if(item.id === action.id){
				var temp = JSON.parse(JSON.stringify(item));
				return { ...temp, doc: new File([action.doc], action.doc.name, { type: action.doc.type }), attachment: new File([item.attachment], item.attachment.name, { type: item.attachment.type })};
			}
			return item;
		})
		//console.log('updatedItems: '+JSON.stringify(updatedItems3));
		return updatedItems3;
	
	case 'UPDATE_ATTACHMENT':
		//console.log('UPDATE_ATTACHMENT reducer');
		const updatedItems4 = state.map(item => {
			if(item.id === action.id){
				var temp = JSON.parse(JSON.stringify(item));
				return { ...temp, doc: new File([item.doc], item.doc.name, { type: item.doc.type }), attachment: new File([action.doc], action.doc.name, { type: action.doc.type })};
			}
			return item;
		})
		//console.log('updatedItems: '+JSON.stringify(updatedItems4));
		return updatedItems4;
	
	case 'UPDATE_TASK':
		//console.log('UPDATE_TASK reducer');
		const updatedItems5 = state.map(item => {
			if(item.id === action.id){
				var temp = JSON.parse(JSON.stringify(item));
				if(action.checked){
					temp.task.push(action.task);
				}else{
					var index = temp.task.indexOf(action.task);
					if (index > -1) {
						temp.task.splice(index, 1);
						temp.product=[];
					}
				}
				return { ...temp, doc: new File([item.doc], item.doc.name, { type: item.doc.type }), attachment: new File([item.attachment], item.attachment.name, { type: item.attachment.type })};
			}
			return item;
		})
		//console.log('updatedItems: '+JSON.stringify(updatedItems5));
		return updatedItems5;
		
	case 'UPDATE_LANG':
		//console.log('UPDATE_LANG (product) reducer');
		const updatedItems9 = state.map(item => {
			if(item.id === action.id){
				var temp = JSON.parse(JSON.stringify(item));
				if(action.checked){
					temp.product.push(action.product);
				}else{
					var index = temp.product.indexOf(action.product);
					if (index > -1) {
						temp.product.splice(index, 1);
					}
				}
				return { ...temp, doc: new File([item.doc], item.doc.name, { type: item.doc.type }), attachment: new File([item.attachment], item.attachment.name, { type: item.attachment.type })};
			}
			return item;
		})
		//console.log('updatedItems: '+JSON.stringify(updatedItems9));
		return updatedItems9;
		
	case 'UPDATE_LP':
		//console.log('UPDATE_LP reducer');
		const updatedItems6 = state.map(item => {
			if(item.id === action.id){
				var temp = JSON.parse(JSON.stringify(item));
				if(action.checked){
					temp.lang.push(action.idLP);
				}else{
					var index = temp.lang.indexOf(action.idLP);
					if (index > -1) {
						temp.lang.splice(index, 1);
					}
				}
				return { ...temp, doc: new File([item.doc], item.doc.name, { type: item.doc.type }), attachment: new File([item.attachment], item.attachment.name, { type: item.attachment.type })};
			}
			return item;
		})
		//console.log('updatedItems: '+JSON.stringify(updatedItems6));
		return updatedItems6;
	
    default:
		return state;
	
	case 'UPDATE_URGENT':
		//console.log('UPDATE_URGENT reducer');
		const updatedItems7 = state.map(item => {
			if(item.id === action.id){
				var temp = JSON.parse(JSON.stringify(item));
				temp.urgent=action.checked;
				return { ...temp, doc: new File([item.doc], item.doc.name, { type: item.doc.type }), attachment: new File([item.attachment], item.attachment.name, { type: item.attachment.type })};
			}
			return item;
		})
		//console.log('updatedItems: '+JSON.stringify(updatedItems7));
		return updatedItems7;
		
	case 'UPDATE_SPECIAL':
		//console.log('UPDATE_SPECIAL reducer');
		const updatedItems8 = state.map(item => {
			if(item.id === action.id){
				var temp = JSON.parse(JSON.stringify(item));
				temp.special=action.checked;
				return { ...temp, doc: new File([item.doc], item.doc.name, { type: item.doc.type }), attachment: new File([item.attachment], item.attachment.name, { type: item.attachment.type })};
			}
			return item;
		})
		//console.log('updatedItems: '+JSON.stringify(updatedItems8));
		return updatedItems8;
	
	case 'UPDATE_ALERT':
		//console.log('UPDATE_ALERT reducer');
		const updatedItems10 = state.map(item => {
			if(item.id === action.id){
				var temp = JSON.parse(JSON.stringify(item));
				temp.alerta=action.checked;
				return { ...temp, doc: new File([item.doc], item.doc.name, { type: item.doc.type }), attachment: new File([item.attachment], item.attachment.name, { type: item.attachment.type })};
			}
			return item;
		})
		//console.log('updatedItems: '+JSON.stringify(updatedItems8));
		return updatedItems10;
		
  }
};



